/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = FronRightTyre
 *
 * 1 = FronLeftTyre
 *
 * 2 = RearRightTyre
 *
 * 3 = RearLeftTyre
 *
 * 4 = SpareTyre
 *
 * 5 = InflationKitOrSpaceSever
 *
 * 6 = Misc
 */
export enum VHCRecordCheckWheelTyreItemTypes {
  FronRightTyre = 0,
  FronLeftTyre = 1,
  RearRightTyre = 2,
  RearLeftTyre = 3,
  SpareTyre = 4,
  InflationKitOrSpaceSever = 5,
  Misc = 6,
}
